import { render } from "./SlowDramaView.vue?vue&type=template&id=585c92d1&scoped=true"
import script from "./SlowDramaView.vue?vue&type=script&lang=js"
export * from "./SlowDramaView.vue?vue&type=script&lang=js"

import "./SlowDramaView.vue?vue&type=style&index=0&id=585c92d1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-585c92d1"]])

export default __exports__